export const PHASE = {
  SCREEN1: "screen1",
  SCREEN2: "screen2",
  SUCCESS: "success",
  FAILED: "failed",
} as const;
